import React from 'react';
import clsx from 'clsx';
import SideDrawer from '../../../../../../../common/_custom/SideDrawer/SideDrawer';
import styles from './ChargeDetailsDrawer.module.scss';

interface ChargeDetailsDrawerProps {
    isDrawerOpen: boolean;
    onClose: () => void;
    selectedRowData: any;
    getSeparatorRowText: (rowIndex: number, toShowSeparator: boolean) => string;
    getBannerStatusColors: (status: string) => { color: string; banner: string };
    convertNumber: (numStr: string) => string;
}

const ChargeDetailsDrawer: React.FC<ChargeDetailsDrawerProps> = ({
    isDrawerOpen,
    onClose,
    selectedRowData,
    getSeparatorRowText,
    getBannerStatusColors,
    convertNumber,
}) => {
    const renderSeparatorRow = (text: string) => {
        return (
            <div className={styles.SeparatorRow}>
                <strong>{text}</strong>
            </div>
        );
    };

    return (
        <>
            {isDrawerOpen && (
                <SideDrawer onClose={onClose} width="60%">
                    <SideDrawer.Header>
                        <div className={styles.DrawerHeader}>Charge Summary</div>
                    </SideDrawer.Header>
                    <div className={styles.DrawerChargeDetails}>
                        <div className={styles.Table}>
                            {/* Render the first separator row */}
                            {renderSeparatorRow(getSeparatorRowText(0, false))}

                            {selectedRowData?.amounts?.map((item: any, index: number) => {
                                const isChargeAmount = item.xValue === 'Charge Amount';
                                const isStatus = item.xValue === 'Status';

                                return (
                                    <React.Fragment key={index}>
                                        <div className={styles.TableBodyRow}>
                                            <div className={styles.TableBodyRowItemKey}>{item.xValue}</div>
                                            <div
                                                className={clsx(styles.TableBodyRowItemValue, {
                                                    [styles.Status]: isStatus,
                                                    [styles.Amount]: isChargeAmount,
                                                })}
                                                style={
                                                    isStatus
                                                        ? {
                                                              background: getBannerStatusColors(item.rowVal).banner,
                                                              color: getBannerStatusColors(item.rowVal).color,
                                                          }
                                                        : {}
                                                }
                                            >
                                                {isChargeAmount
                                                    ? convertNumber(item.rowVal) // Format the charge amount
                                                    : item.rowVal}
                                            </div>
                                        </div>

                                        {/* Render "Particulars of the Charge" separator row */}
                                        {isStatus && renderSeparatorRow(getSeparatorRowText(index, true))}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </SideDrawer>
            )}
        </>
    );
};

export default ChargeDetailsDrawer;
